(function () {
    "use strict";

    angular.module("app").directive("inlineInstructions", InlineInstructionsDirective);

    InlineInstructionsDirective.$inject = ["settingsService",];
    function InlineInstructionsDirective(settingsService,) {
        return {
            restrict: "A",
            scope: {
                instruction: "@inlineInstructions"
            },
            templateUrl: function (_elem, attrs) {
                return `${settingsService.GetBaseUrl()}api/Instructions/${attrs.inlineInstructions}/${settingsService.locale}`;
            },
        };
    }
})();